
<block-ui></block-ui>
  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="UserDepartmentForm">
            <BBSF-TextBox [hidden]="true" [options]="DepartmentIdTextBox" [group]="UserDepartmentForm">
            </BBSF-TextBox>
            <BBSF-TextBox [options]="searchTextBox" [group]="UserDepartmentForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->
          <button type="button" class="btn btn-sm btn-primary" title="Add" (click)="showAddUserToDepartmentModal(AddUserToDepartmentModal)">
            <i class="fas fa-plus me-1"></i>
            {{UtilityService.getResourceValue("Add")}}
          </button>

          <!-- end::Menu -->
        </div>
      </div>
      <div class="card-body py-3">
        <div class="table-responsive">
          <!--begin::Permission list-->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">

                <th class="min-w-150px">{{UtilityService.getResourceValue("Name")}}</th>
                <th class="min-w-150px">{{UtilityService.getResourceValue("Email")}}</th>
                <th class="min-w-150px">{{UtilityService.getResourceValue("Roles")}}</th>
                <th class="min-w-50px">{{UtilityService.getResourceValue("Action")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

              <tr *ngFor="let user of UserDepartmentPagingResult">

                <td>
                  <span *ngIf="language=='en'" class="text-dark">{{user.name.english}}</span>
                  <span *ngIf="language=='ar'" class="text-dark">{{user.name.arabic}}</span>

                </td>
                <td>{{user.email}}</td>
                <td>{{user.userPermsets}}</td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <a ngbDropdownItem class="drop-item px-3"
                         (click)="showDeleteUserFromDepartmentModal(user,deleteUserDepartmentModal)">
                        <span class="drop-link px-3">{{UtilityService.getResourceValue("Delete")}}</span>
                      </a>
                    </mat-menu>
                  </div>

                </td>
              </tr>
              <tr *ngIf="UserDepartmentPagingResult.length == 0">
                <td colspan="4">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>
          <!--end::Permission list-->
        </div>

      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setUserDepartmentListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="UserDepartmentPaging" [group]="UserDepartmentForm" #UserDepartmentPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>

  </div>




  <!--delete Modal-->
  <ng-template #deleteUserDepartmentModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{UtilityService.getResourceValue("Delete")}} {{UtilityService.getResourceValue("User")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{UtilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteUserFromDepartmentModal id="CloseDeleteUserFromDepartmentModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{UtilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deleteUserFromDepartment()"
                class="btn btn-light-danger btn-sm ">
          {{UtilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>

  <!--add Modal-->
  <ng-template #AddUserToDepartmentModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3"> {{UtilityService.getResourceValue("Add")}} {{UtilityService.getResourceValue("User")}} </h1>
      </div>
      <form [formGroup]="AddUsersToDepartmentForm"
            (ngSubmit)="addUserToDepartment()">
        <div class="row">
          <div class="col-md-12">
            <BBSF-TagsInput [options]="UserAutoComplete" [group]="AddUsersToDepartmentForm">
            </BBSF-TagsInput>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #CloseAddUsersToDepartment id="CloseAddUsersToDepartment" type="button"
                  class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
            {{UtilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{UtilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>
